"use client";

import Clarity from "@microsoft/clarity";


export function ClarityScript() {
    const projectId = process.env.NEXT_PUBLIC_CLARITY_ID;

    if (!projectId) {
        // eslint-disable-next-line no-console
        console.warn("Clarity project ID is not set");
        return null;
    }

    Clarity.init(projectId);

    return null;
}